/**
 * @generated SignedSource<<e775b8521422892e444eb14d9b546186>>
 * @relayHash 86cbb6141d41445e5997487fadb08c1a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID eb2922bd633c040d390f1ab64493360bbc30c2e6e6bb1bcf12778f077c5f357c

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcVirtualAgentLandingQuery } from './srcVirtualAgentLandingQuery.graphql';

const node: PreloadableConcreteRequest<srcVirtualAgentLandingQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "eb2922bd633c040d390f1ab64493360bbc30c2e6e6bb1bcf12778f077c5f357c",
    "metadata": {},
    "name": "srcVirtualAgentLandingQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
